<template>
  <div class="keno-classic game-table">
    <div class="game-table-title">
      <div class="row">
        <div class="col-xs-7">
          <h4>
            <i class="fa fa fa-cubes"></i>
            <span class="kind">{{ $t('games.keno_classic') }}</span>
          </h4>
        </div>
        <div class="col-xs-5 game-info text-right">
          <span v-if="round > 0">
            {{ $t('messages.round') }} {{ gameInfo }}
          </span>
          <span v-else>{{ $t('messages.break') }}</span>
        </div>
      </div>
    </div>
    <div class="game-table-detail clearfix">
      <div class="game-table-cover">
      </div>
    </div>
    <!-- <div class="game-table-detail clearfix">
      <div class="game-table-preview dragscroll">
        <div class="game-table-panel" style="height:100%; width:800px;">
          <div class="box-stat-wrapper">
            <div class="box-col" v-for="(col, c) in fixing.col" :key="'col-' + c">
              <template v-for="(row, r) in fixing.row">
                <span :key="c+r" :data-position="c+'.' +r" v-if="renderScore(r, c)" :class="isBigSmall(adoptation['score'][c + '.' + r])">
                  {{ adoptation['score'][c + '.' + r] }}
                </span>
                <span :key="c+r" :data-position="c+'.' +r" v-else>
                  &nbsp;
                </span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="game-table-sub clearfix">
      <div class="row">
        <div class="col-lg-6 col-xs-5">
          <span>
            {{ $t('messages.bettime', { time: duration }) }}
          </span>
        </div>
        <div class="col-lg-6 col-xs-7 pull-right">
          <!-- Waiting implement -->
        </div>
      </div>
    </div>
    <div class="game-table-bottom clearfix">
      <span class="info">
        <i class="fa fa-info-circle"></i> {{ $t('messages.limit', { limit: betLimit }) }} |
        <i class="fa fa-users"></i> {{ $t('messages.userOnline', { count: online }) }}
      </span>
      <a :href="route" class="btn btn-primary">{{ $t('messages.playNow') }}</a>
    </div>
  </div>
</template>
<script>
  import api from '../../../keno/api'
  import Roadmap from '../../../keno/lib/KenoRoadmap'
  const roadmap = new Roadmap()
  export default {
    name: 'game-keno',
    props: {
      user: {
        required: true,
        type: Object
      },
      kind: {
        required: true,
        type: String
      },
      tableId: {
        required: true,
        type: [Number, String]
      }
    },
    data () {
      return {
        config: {},
        stats: {},
        channels: {
          personal: null,
          baccarat: null,
          sessions: null
        },
        fixing: {
          col: 20,
          row: 6
        },
        statistics: {
          score: []
        },
        adoptation: {
          score: []
        },
        betLimit: null
      }
    },
    mounted () {
      this.initialize()
    },
    methods: {
      initialize () {
        api.game.getGameConfigWithInformation(this.tableId,
          (response) => {
            this.config = _.omit(response.data, ['info.detail.statistic'])
            this.stats = _.get(response.data, 'info.detail.statistic', [])
          },
          (error) => {
            // Some api need to force user re-login, because jwt is not work.
            const status = _.get(error, 'response.status')
            if (status === 401) {
              location.href = '/logout'
              return
            }
          }
        )
      },
      renderScore (row, col) {
        const stat = _.find(this.statistics['score'], (v) => v.column === col && v.row === row)
        if (_.has(stat, 'marker')) {
          this.adoptation['score'][`${stat.column}.${stat.row}`] = stat.score
          return true
        }
        return null
      },
      isBigSmall (score) {
        return _.inRange(score, 210, 810) ? 'is-small' : (_.inRange(score, 811, 1411) ? 'is-big' : 'is-mean')
      }
    },
    computed: {
      online () {
        return _.get(this.config, 'info.online')
      },
      duration () {
        return _.get(this.config, 'game.bet_duration')
      },
      gameInfo () {
        const shoe = _.padStart(this.shoe, 4, 0)
        const round =  _.padStart(this.round, 3, 0)
        return `${shoe}-${round}`
      },
      shoe () {
        return _.get(this.config, 'info.detail.shoe')
      },
      round () {
        return _.get(this.config, 'info.detail.round')
      },
      title () {
        return _.get(this.config, 'table.title')
      },
      route () {
        return '/games/live/keno_classic/' + this.tableId
      }
    },
    watch: {
      'user': {
        handler: function (value, old) {
          const game = _.get(value, 'config.games.keno.bet_limit.CLASSIC')
          this.betLimit = `${game.min}-${this.$options.filters.number(game.max)}`
        },
        deep: false
      },
      'stats': {
        handler: function (value, old) {
          this.statistics = roadmap.statistic(value, this.fixing.col, this.fixing.row, true)
        },
        deep: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/pages/games/KenoClassic.vue